export type SignOrderDateValue = string | number | Date | null | undefined;

function getSignOrderLocale(language: string | null | undefined): string {
  return language === 'de' ? 'de-DE' : 'en-US';
}

function toValidDate(value: SignOrderDateValue): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value !== 'string' && typeof value !== 'number') {
    return null;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatSignOrderDate(value: SignOrderDateValue, language: string | null | undefined): string {
  const date = toValidDate(value);
  if (!date) return '';

  return new Intl.DateTimeFormat(getSignOrderLocale(language), {
    dateStyle: 'medium',
  }).format(date);
}

export function formatSignOrderDateTime(value: SignOrderDateValue, language: string | null | undefined): string {
  const date = toValidDate(value);
  if (!date) return '';

  return new Intl.DateTimeFormat(getSignOrderLocale(language), {
    dateStyle: 'medium',
    timeStyle: 'medium',
  }).format(date);
}
